module.exports = __webpack_public_path__ + "bin/e507dfc8cf01c48ee0181f1a21158db8.jpg";